<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-title">Contents</h1>
<p class="toc-fm"><a href="#/006_Preface#fm-1"><em>Preface</em></a></p>
<p class="toc-fm"><a href="#/007_Introduction#fm-2">Introduction: Female Discipleship in the Gospels</a></p>
<p class="toc-chap"><span href="#/008_Chapter01#ch-1" title="Link target outside of Sample">1.<span class="sp">A Woman’s World in the First Century</span></span></p>
<p class="toc-chap"><span href="#/009_Chapter02#ch-2" title="Link target outside of Sample">2.<span class="sp">Female Discipleship in the Gospel of Mark</span></span></p>
<p class="toc-chap"><span href="#/010_Chapter03#ch-3" title="Link target outside of Sample">3.<span class="sp">Female Discipleship in the Gospel of Matthew</span></span></p>
<p class="toc-chap"><span href="#/011_Chapter04#ch-4" title="Link target outside of Sample">4.<span class="sp">Female Discipleship in the Gospel of Luke</span></span></p>
<p class="toc-chap"><span href="#/012_Chapter05#ch-5" title="Link target outside of Sample">5.<span class="sp">Female Discipleship in the Acts of the Apostles</span></span></p>
<p class="toc-chap"><span href="#/013_Chapter06#ch-6" title="Link target outside of Sample">6.<span class="sp">Female Discipleship in the Gospel of John</span></span></p>
<p class="toc-bm"><span href="#/014_Conclusion#bm-1" title="Link target outside of Sample">Conclusion: Women in the Gospels as Models of Discipleship</span></p>
<p class="toc-bm1"><span href="#/015_Bibliography#bm-2" title="Link target outside of Sample"><em>Bibliography</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005_Contents.vue?25e1f595